export function runPdfTransformWorker({ buffer, mode, password = "", preset = "balanced", timeoutMs = 120_000 }) {
  return new Promise((resolve, reject) => {
    const worker = new Worker("/dist/pdf-transform-worker.js", { type: "module" });
    const id = crypto.randomUUID();
    const source = buffer instanceof ArrayBuffer
      ? buffer
      : buffer?.buffer?.slice(buffer.byteOffset || 0, (buffer.byteOffset || 0) + buffer.byteLength);
    if (!(source instanceof ArrayBuffer)) {
      worker.terminate();
      reject(new Error("The PDF transform input is invalid."));
      return;
    }
    const timeout = window.setTimeout(() => finish(() => reject(new Error("The PDF processor timed out."))), timeoutMs);
    const finish = callback => {
      window.clearTimeout(timeout);
      worker.terminate();
      callback();
    };
    worker.addEventListener("message", event => {
      if (event.data?.id !== id) return;
      if (event.data.ok) finish(() => resolve(event.data.buffer));
      else {
        const error = new Error(event.data.detail || "The PDF could not be processed.");
        error.code = event.data.code || "PROCESS_FAILED";
        finish(() => reject(error));
      }
    });
    worker.addEventListener("error", () => finish(() => reject(new Error("The PDF processor could not start."))), { once: true });
    worker.postMessage({ id, mode, password, preset, buffer: source }, [source]);
  });
}
